import { render, staticRenderFns } from "./IconWorld.vue?vue&type=template&id=2d73005b&scoped=true&"
import script from "./IconWorld.vue?vue&type=script&lang=js&"
export * from "./IconWorld.vue?vue&type=script&lang=js&"
import style0 from "./IconWorld.vue?vue&type=style&index=0&id=2d73005b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d73005b",
  null
  
)

export default component.exports